// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} MedicalPatient
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} facility
 */

const state = {
  /** @type {MedicalPatient[]} */
  patients: [],
  /**
   * total number of patients for the query
   * @type {number}
   **/
  patientsTotal: 0
};

export default state;
